module.exports = __webpack_public_path__ + "img/1201.68418728.png";